export function Wordmark() {
  return (
    <span className="wordmark">
      Vox<em>Stage</em>
    </span>
  );
}
